'use client';
var classes = {"flag":"me-e3e6c0b4"};

export { classes as default };
//# sourceMappingURL=flagpack.module.css.mjs.map
